import * as ko from "knockout";
import entityBase from "entityBase";
import { CustomObservables } from "CustomObservables";

export class time_commit_view extends entityBase {
  tc_id: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  response_code: KnockoutObservable<string>;
  response_type: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  commit_dt: KnockoutObservable<any>;
  protected commit_dttm: KnockoutObservable<any>;

  constructor(item: any) {
    super();
    this.tc_id = ko.observable(item.tc_id);
    this.status = ko.observable(item.status);
    this.response_code = ko.observable(item.response_code);
    this.response_type = ko.observable(item.response_type);
    this.request_id = ko.observable(item.request_id);
    this.commit_dt = ko.observable(this.formatJSONDate(item.commit_dttm));
    this.commit_dttm = CustomObservables.formattedDateTimeObservable(this.commit_dt);
  }
}
